import Typography from '@pedidosya/web-fenix/foundations/Typography';
import styled from 'styled-components';
import { TagWeb } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';

const textProps = vendorItemTokens.properties.fonts;
const vendorItemStyles = vendorItemTokens.categories.default;

const Container = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.space('spacing-component-medium')};
`;

const ActionContainer = styled.div`
  margin-left: ${({ theme, addMargin }) =>
    addMargin &&
    theme.space(vendorItemStyles.shared.headerBottomRowLeftColumnGap)};
`;

export const VendorStatusMedium = ({ title, action }) => (
  <Container>
    <Typography
      color={textProps.vendorStatusMedium.textColor}
      token={textProps.vendorStatusMedium.typography}
    >
      {title}
    </Typography>

    {!!action && (
      <ActionContainer addMargin={!!action && !!title}>
        <TagWeb
          category="informative"
          className="vendor-status-action"
          size="small"
          label={action}
        />
      </ActionContainer>
    )}
  </Container>
);
